module.exports = __webpack_public_path__ + "img/icon-enlarge-shimen.e1f91f5.svg";